<template>
  <div class="bot-selector">
    <a-modal
      title="绑定群关系"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :closable="false"
      :centered="true"
      :destroyOnClose="true"
      cancelText="取消"
      okText="确定"
      width="800px"
      style="height: 100px"
    >
      <!-- 机器人 -->
      <div class="avatar-36-con" style="margin: 10px 0 10px 0">
        <img class="avatar" :src="data != null ? data.base_info.avatar_url : 'defaut'"/>
        <div class="nickname">{{data != null ? data.base_info.nickname + '（' + data.base_info.username + '）' : 'default'}}</div>
      </div>
      <div v-if="chatroomList === null" style="margin-top: 15px">
        {{ '正在获取数据...' }}
      </div>
      <div v-else>
        <div>
          选择群：
          <a-select notFoundContent="该机器人所在的群似乎都已经绑定成功" optionLabelProp="nickname" style="width: 60%" mode="multiple"
                    @select="onSelect" @deselect="onDeselect" :filterOption="filterOption">
            <a-select-option :nickname="chatroom.nickname" :key="chatroom.chatroomname" v-for="chatroom in chatroomList" :value="chatroom.chatroomname">
              {{ chatroom.nickname }}
            </a-select-option>
          </a-select>
        </div>
        <div style="margin-top: 15px">
          选择一个客户：
          <a-select notFoundContent="没有找到客户信息" optionLabelProp="nickname" style="width: 60%" @change="handleChange">
            <a-select-option :nickname="client.nickname" :key="client.client_id + '_' + client.nickname" v-for="client in clientList" :value="client.client_id + '_' + client.nickname">
              <div class="avatar-36-con" style="margin: 10px 0 10px 0">
                <img class="avatar" :src="client.avatar_url"/>
                <div class="nickname">{{client.nickname + '（' + client.username + '）'}}</div>
              </div>
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import ASelect from 'ant-design-vue/es/select/index'
import AInput from 'ant-design-vue/es/input/Input'
const axios = require('axios')
export default {
  name: 'BindChatroomModal',
  components: {AInput, ASelect},
  props: ['visible', 'confirmLoading', 'data', 'chatroomnameSelected'],
  data () {
    // console.log(this.data)
    return {
      clientList: null,
      chatroomList: null,
      clientId: null,
      getUnbindChatroomListUrlPostFix: 'UChatroom/get_unbind_chatroom_list',
      getBindClientListUrlPostFix: 'UChatroom/get_bind_client_list'
    }
  },
  watch: {
    visible: function (newValue, oldValue) {
      // console.log('count', newValue, oldValue)
      if (newValue === true) {
        this.fetchUnbindChatroomList()
        this.fetchClientList()
      } else {
        this.clientList = null
        this.chatroomList = null
        this.clientId = null
      }
    }
  },
  computed: {
    getUnbindChatroomListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getUnbindChatroomListUrlPostFix
    },
    getBindClientListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBindClientListUrlPostFix
    }
  },
  methods: {
    handleOk () {
      // console.log('handleOk')
      this.onFinish()
    },
    handleCancel () {
      // console.log('handleCancel')
      this.onCancel()
    },
    onFinish () {
      // console.log('onFinish', this.selectedBotList)
      this.$emit('on-finish', this.data.username, this.clientId, this.chatroomnameSelected)
      // console.log('$emit', this.selectedBotList)
    },
    onCancel () {
      // console.log('onCancel', this.selectedBotList)
      this.$emit('on-cancel')
    },
    fetchUnbindChatroomList () {
      axios.post(this.getUnbindChatroomListUrl, {
        bot_username: this.data.username,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log(data.data.content.unbind_chatroom_list)
            this.chatroomList = data.data.content.unbind_chatroom_list
            this.bindClientVisible = false
            this.bindClientConfirmLoading = false
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    fetchClientList () {
      axios.post(this.getBindClientListUrl, {
        bot_username: this.data.username,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log(data.data.content.bind_client_list)
            this.clientList = data.data.content.bind_client_list
            this.bindClientVisible = false
            this.bindClientConfirmLoading = false
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    filterOption (input, option) {
      // console.log('filterOption', input, option)
      var res = false
      var nickname = option.data.attrs.nickname
      if (nickname && nickname.indexOf(input) !== -1) {
        res = true
      }
      return res
    },
    onSelect (value, option) {
      // console.log('onSelect', value, option)
      this.chatroomnameSelected.push(value)
      // console.log('chatroomnameSelected', this.chatroomnameSelected)
    },
    onDeselect (value, option) {
      // console.log('onDeselect', value, option)
      this.chatroomnameSelected = this.chatroomnameSelected.filter(t => t !== value)
      // console.log('chatroomnameSelected', this.chatroomnameSelected)
    },
    handleChange (value, option) {
      // console.log('handleChange', value, option)
      this.clientId = value.split('_')[0]
      // console.log('handleChange', this.clientId)
    }
  }
}
</script>

<style scoped>

</style>
